import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";

type GetAxnAdminSecurityRulesRequestResponse = {
    axnAdminSecurityRules: Array<AxnAdminSecurityRule>
};

export const getAxnAdminSecurityRulesRequest = async (): Promise<{ data: GetAxnAdminSecurityRulesRequestResponse, error: any }> => {
    const route = apiRoutes.managementConsole.axnadmin.security.rules;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};